<template>
  <div class="orders-details">
    <v-card class="mx-auto">
      <v-card-title class="headline white--text" style="background-color: #FF5252">
        <span>Order n°{{order.number}}</span>
      </v-card-title>
      <v-card-text class="mt-3">
        <v-tabs fixed-tabs v-model="activeTab">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#receipt">Receipt</v-tab>
          <v-tab href="#context">Context</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item value="receipt">
            <v-card flat class="mt-4">
              <Receipt :order="order" />
            </v-card>
          </v-tab-item>
          <v-tab-item value="context">
            <v-card flat class="mt-4">
              <v-row>
                <template v-for="v in displayValues">
                  <v-col cols="6" :key="v.label">
                    <v-text-field
                      class="my-0 py-1"
                      :value="v.value"
                      :label="v.label"
                      filled
                      disabled
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>
              <v-row>
                <v-col cols="12" align="end">
                  <v-btn icon @click="debug = !debug">
                    <v-icon>{{debug ? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="debug">
                <template v-for="v in debugValues">
                  <v-col cols="6" :key="v.label">
                    <v-text-field
                      class="my-0 py-1"
                      :value="v.value"
                      :label="v.label"
                      filled
                      disabled
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Receipt from "@/components/Orders/Receipt";
export default {
  components: { Receipt },
  props: { order: { type: Object } },
  data: function () {
    return {
      activeTab: "receipt",
      debug: false,
    };
  },
  computed: {
    displayValues() {
      return [
        { label: "Kitchen", value: this.order.kitchen },
        { label: "Status", value: this.order.status },
        { label: "Concept", value: this.order.concept },
        { label: "Shift", value: this.order.shift },
        { label: "Platform", value: this.order.platform },
        { label: "Placed At", value: this.order.placed_at },
        { label: "Country", value: this.order.country_code },
        { label: "Ready At", value: this.order.ready_at },
      ];
    },
    debugValues() {
      return [
        { label: "UUID", value: this.order.uuid },
        { label: "Location UUID", value: this.order.location_uuid },
        {
          label: "Platform Order UUID",
          value: this.order.platform_order_uuid,
        },
        { label: "Timezone", value: this.order.timezone },
        { label: "Lunch Shift", value: this.order.lunch_shift },
        { label: "Dinner Shift", value: this.order.dinner_shift },
      ];
    },
  },
};
</script>
